import React from "react";
import style from "../DetailContainer.module.scss";

import { BsFileText, BsCalendarCheck } from "react-icons/bs";
import { FaRegFileAlt } from "react-icons/fa";
import { MdNotes } from "react-icons/md";

import Summary from "./TabsData/Summary";
import CandidateResume from "./TabsData/Resume";
import { calculateAge, dateFormateDD, formatDateTime } from "../../../utility";
import Interviews from "./TabsData/Interviews";
import Notes from "./TabsData/Notes";

function CandidateTabs({ basicData, resumeData,interviewData, activeTab, setActiveTab,refreshResume ,reloadInterviews }) {

const candidate = Array.isArray(basicData) ? basicData[0] : basicData;

  const candidateData = {
    fullName: `${candidate?.first_name || ""} ${candidate?.last_name || ""}`.trim(),

    firstName: candidate?.first_name || "",
    lastName: candidate?.last_name || "",
    // candidate_id: candidate?.last_name || "",

    idNumber: candidate?.candidate_id || "",
    gender: candidate?.gender || "",

    education: candidate?.qualification || "",
    specialization: candidate?.specification || "",
    passedOutYear: candidate?.passed_out_year || "",

    position: candidate?.job_category || "",
    currentCompany: candidate?.company_name || "",

    currentLocation: candidate?.city || "",
    preferredLocation: candidate?.pref_location || "",

    dob: candidate?.date_of_birth
      ? dateFormateDD(candidate.date_of_birth)
      : "",

    age: candidate?.date_of_birth
      ? calculateAge(dateFormateDD(candidate.date_of_birth))
      : "",

    phone: candidate?.mobile_number || "",
    whatsapp: candidate?.whatsapp_number || "",
    email: candidate?.email_id || "",

    guardianName: candidate?.relation_name || "",
    guardianPhone: candidate?.emergency_contact_number || "",

    sourceFrom: candidate?.from_source || "",

    createdOn: candidate?.created_time
      ? formatDateTime(candidate.created_time)
      : "",

    entryOn: candidate?.entry_on
      ? formatDateTime(candidate.entry_on)
      : "",

    lastUpdated: candidate?.created_time
      ? formatDateTime(candidate.created_time)
      : "",

    totalYearsOfExp:candidate?.exp_in_years + "." + candidate?.exp_in_months +" years EXP",

    currentlyWorking: candidate?.currently_working || "",
    currentIndustry: candidate?.industry || "",
    employmentType: candidate?.job_type || "",
    workingHours: candidate?.job_work_hours || "",

    currentSalary: candidate?.take_home_salary || "",
    expectedSalary: candidate?.expected_salary || "",

    noticePeriod: candidate?.notice_period || "",

    jobChangeReason: candidate?.reason_for_jobchange || "",
    description: candidate?.notes || "",

    keySkill: candidate?.key_skill || "",

    experienced: candidate?.experienced ?? null,
    companyLocation: candidate?.company_location ?? null,
    companyName: candidate?.company_name ?? null,
    assigned_user_name: candidate?.assigned_user_name ?? null,
};
  const tabs = [
    { name: "Summary", icon: <FaRegFileAlt /> },
    { name: "Resume", icon: <BsFileText /> },
    { name: "Interviews", icon: <BsCalendarCheck /> },
    { name: "Notes", icon: <MdNotes /> },
  ];
// console.log(candidateData,"candidateData");

  return (
    <div className={style.tabsContainer}>

      {/* TAB HEADER */}
      <div className={style.tabHeader}>
        {tabs.map((tab) => (
          <div
            key={tab.name}
            className={`${style.tabItem} ${
              activeTab === tab.name ? style.active : ""
            }`}
            onClick={() => setActiveTab(tab.name)}
          >
            {tab.icon}
            <span>{tab.name}</span>
          </div>
        ))}
      </div>

      {/* TAB CONTENT */}
      <div className={style.tabContent}>

        {activeTab === "Summary" && (
          <Summary candidateData={candidateData} />
        )}

        {activeTab === "Resume" && (
          <CandidateResume id={candidate.candidate_id} data={resumeData} refreshResume={refreshResume} />
        )}

        {activeTab === "Interviews" && (
          <Interviews data={interviewData} reloadInterviews={reloadInterviews} />
        )}

        {activeTab === "Notes" && (
          <Notes id={candidate.candidate_id} />
        )}

      </div>
    </div>
  );
}

export default CandidateTabs;